/**
 * Timezone Utilities
 * Single source of truth for the user's device timezone on the client side.
 *
 * Usage:
 *   import { getUserTimezone } from '@/shared/utils/core/timezone';
 *   const tz = getUserTimezone(); // e.g. 'America/New_York'
 *
 * Server-side (Cloud Functions): timezone is stored at top-level in userProfiles.timezone
 * and extracted with getLocalDayKey() / Intl.DateTimeFormat using that stored value.
 */

/**
 * Get the user's IANA timezone from their device locale settings.
 * @returns {string} IANA timezone string, e.g. 'America/New_York', 'Europe/London'
 */
export function getUserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    // Intl API unavailable (sandboxed env, very old browser) — fall back to UTC
    return 'UTC';
  }
}
